/**
 * The general structure of accordion content should follow the format below.
 *
 * <div class="accordion-button" aria-controls="controlled-content">
 *     <p>Title</p>
 * </div>
 * <div class="accordion-content" id="controlled-content" aria-expanded="false">
 *     <p>Content</p>
 * </div>
 *
 * Each .accordion-button elements needs a corresponding aria-controls attribute with the
 * id of the content it controls. The content should have the accordion-content class.
 */
export const accordion = () => {
    window.addEventListener('load', function () {
        const buttons = document.querySelectorAll('.accordion-button');

        if (0 === buttons.length) {
            return;
        }

        for (let i = 0; i < buttons.length; i++) {
            const content = document.getElementById(buttons[i].getAttribute('aria-controls'));
            buttons[i].addEventListener('click', function (e) {
                e.preventDefault();
                for (let j = 0; j < buttons.length; j++) {
                    const controlledByButton = document.getElementById(buttons[j].getAttribute('aria-controls'));
                    if (e.currentTarget !== buttons[j] || e.currentTarget.classList.contains('expanded')) {
                        controlledByButton.style.height = '';
                        controlledByButton.setAttribute('aria-expanded', 'false');
                        buttons[j].classList.remove('expanded');
                    } else {
                        content.style.height = `${content.scrollHeight}px`;
                        content.setAttribute('aria-expanded', 'true');
                        buttons[j].classList.add('expanded');
                    }
                }
            });
        }
    })
};
